import axios from 'axios';
import * as config from 'app/configs/configs';
import { getAuth, removeAuth } from 'app/modules/auth';

const headers = config.getHeaders();

const instance = axios.create({
    headers: {
        ...headers
    },
    validateStatus: (_) => true
});

instance
    .interceptors
    .request
    .use(function(config) {
        if (getAuth()?.api_token && config?.headers) {
            config.headers['Authorization'] = `Bearer ${getAuth()?.api_token}`;
        }
        return config;
    }, function(error) {
        return Promise.reject(error);
    });

instance.interceptors.response.use(function(response) {
    if (response?.status === 401) { // Unauthorized
        removeAuth();
        window.location.href = '/app/auth';
    }
    return response
}, function(error) {
    if (error?.response?.status === 401) { // Unauthorized
        removeAuth();
        window.location.href = '/app/auth';
    }
    return Promise.reject(error)
})

export default instance;
